import React from 'react';
import { Phone, Mail, MapPin, Instagram, Facebook, Clock } from 'lucide-react';

const ComingSoonPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#1a365d] via-[#1e4175] to-[#1a365d] flex flex-col items-center justify-center p-6 relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-64 h-64 bg-[#f87171]/10 rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-white/5 rounded-full blur-3xl" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#f87171]/5 rounded-full blur-3xl" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center max-w-2xl mx-auto">
        {/* Logo */}
        <div className="mb-8">
          <img loading="lazy" decoding="async"
            src="https://customer-assets.emergentagent.com/job_c6f5c8a0-7f54-45e5-978e-c429b489b9e5/artifacts/a0f5bcjp_vertical%20%281%29-marko_bela.png"
            alt="Fizioterapija Saša Panič"
            className="h-48 md:h-56 mx-auto"
          />
        </div>

        {/* Main message */}
        <h1 className="text-3xl md:text-5xl font-bold text-white mb-4">
          Nova spletna stran
          <span className="block text-[#f87171] mt-2">prihaja kmalu</span>
        </h1>

        <p className="text-white/80 text-lg md:text-xl mb-8 leading-relaxed">
          Pripravljamo novo, sodobno spletno stran za boljšo uporabniško izkušnjo. 
          <br className="hidden md:block" />
          Za naročilo termina nas kontaktirajte.
        </p>

        {/* Divider */}
        <div className="w-24 h-1 bg-[#f87171] mx-auto mb-8 rounded-full" />

        {/* Contact cards */}
        <div className="grid sm:grid-cols-2 gap-4 mb-8">
          {/* Phone */}
          <a
            href="tel:+38640464886"
            className="bg-white/10 backdrop-blur-sm hover:bg-white/20 transition-all rounded-2xl p-6 flex flex-col items-center gap-3 group"
          >
            <div className="w-14 h-14 bg-[#f87171] rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
              <Phone className="w-6 h-6 text-white" />
            </div>
            <div>
              <p className="text-white/60 text-sm mb-1">Pokličite nas</p>
              <p className="text-white font-semibold text-lg">040 464 886</p>
            </div>
          </a>

          {/* Email */}
          <a
            href="mailto:fizioterapija@sasapanic.com"
            className="bg-white/10 backdrop-blur-sm hover:bg-white/20 transition-all rounded-2xl p-6 flex flex-col items-center gap-3 group"
          >
            <div className="w-14 h-14 bg-[#f87171] rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
              <Mail className="w-6 h-6 text-white" />
            </div>
            <div>
              <p className="text-white/60 text-sm mb-1">Pišite nam</p>
              <p className="text-white font-semibold text-lg">fizioterapija@sasapanic.com</p>
            </div>
          </a>
        </div>

        {/* Location & Hours */}
        <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 mb-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-center gap-6 text-white/80">
            <div className="flex items-center justify-center gap-2">
              <MapPin className="w-5 h-5 text-[#f87171]" />
              <span>Dunajska c. 154, Ljubljana</span>
            </div>
            <div className="hidden md:block w-px h-5 bg-white/20" />
            <div className="flex items-center justify-center gap-2">
              <Clock className="w-5 h-5 text-[#f87171]" />
              <span>Pon - Pet: 8:00 - 19:00</span>
            </div>
          </div>
        </div>

        {/* Social links */}
        <div className="flex items-center justify-center gap-4">
          <a
            href="https://www.instagram.com/fizioterapija_sasa_panic/"
            target="_blank"
            rel="noopener noreferrer"
            className="w-12 h-12 bg-white/10 hover:bg-[#f87171] rounded-full flex items-center justify-center transition-all group"
          >
            <Instagram className="w-5 h-5 text-white/70 group-hover:text-white" />
          </a>
          <a
            href="https://www.facebook.com/FizioterapijaSasaPanic"
            target="_blank"
            rel="noopener noreferrer"
            className="w-12 h-12 bg-white/10 hover:bg-[#f87171] rounded-full flex items-center justify-center transition-all group"
          >
            <Facebook className="w-5 h-5 text-white/70 group-hover:text-white" />
          </a>
        </div>
      </div>

      {/* Footer */}
      <div className="absolute bottom-6 left-0 right-0 text-center">
        <p className="text-white/40 text-sm">
          © {new Date().getFullYear()} Fizioterapija Saša Panič. Vse pravice pridržane.
        </p>
      </div>
    </div>
  );
};

export default ComingSoonPage;
